/**
 * 驗證傳入的Menu物件，並判斷其Link確認是不是連結
 * @param payload: Menu物件
 * @returns Boolean
 */

import type { IFormatMenu } from '@/stores/menuStore';

const validIsNuxtLink = (payload: IFormatMenu): boolean => {
  if (payload.link && payload.subMenus.length <= 0) {
    return true;
  }
  return false;
};

export default validIsNuxtLink;
